import { GET_ONBOARDING_NOTIFICATIONS, GET_USER, REDIRECT_TO_LOGIN } from '../types';
import { UserActions, GetUserAction, RedirectToLoginAction, GetNotificationsAction } from '../types';
import { Dispatch } from 'react';
import { OnboardingNotifications } from '../../../../models/OnboardingNotifications';
import { User } from '../../../../models/User';
import { fetchUser } from '../../../../services/UserAPI';

export function getUser(): (dispatch: Dispatch<UserActions>) => void {
    return async (dispatch: Dispatch<UserActions>) => {
        try {
            const { user, onboarding } = await fetchUser();
            dispatch(receiveUser(user));
            dispatch(receiveOnboardingData(onboarding));

        } catch (error) {
            dispatch(receiveUserWithError());
        }
    };
}

const receiveOnboardingData = (onboardingData: OnboardingNotifications): GetNotificationsAction => {
    return {
        type: GET_ONBOARDING_NOTIFICATIONS,
        payload: {
            onboardingData,
        },
    };
};

const receiveUser = (user: User): GetUserAction => {
    return {
        type: GET_USER,
        payload: {
            user,
        },
    };
};

const receiveUserWithError = (): RedirectToLoginAction => {
    return {
        type: REDIRECT_TO_LOGIN,
        payload: {},
    };
};
